import {IColumns} from '@baidu/icloud-ui-pro-table';

export const columns: IColumns = [
    {
        title: 'CPU',
        dataIndex: 'cpu',
        render(value) {
            return value;
        },
    },
    {
        title: '内存',
        dataIndex: 'memory',
        render(value) {
            return value;
        },
    },
    {
        title: '价格',
        dataIndex: 'price',
        render(value) {
            return `￥${value}/分钟`;
        },
    },
];
